'use client'

import { useSearchParams } from 'next/navigation'
import {
  createContext,
  FunctionComponent,
  ReactNode, Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'

export type AlertNotificationContextType = {
  onCloseNotification: () => void

  addNotification: (message: string) => void
  message: string | null
}

export const AlertNotificationContext = createContext<AlertNotificationContextType>({
  onCloseNotification: () => {},
  addNotification: () => {},
  message: null,
})

const AlertNotificationComponent = () => {
  const { addNotification } = useContext(AlertNotificationContext)
  const searchParams = useSearchParams()
  const [defaultMessage] = useState<string | null>(searchParams?.get('notification') || null)

  useEffect(() => {
    if (defaultMessage) {
      addNotification(defaultMessage)
    }
  }, [defaultMessage])

  return <></>
}

const AlertNotificationProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
 const timeOutRef = useRef<NodeJS.Timeout>()
  const [message, setMessage] = useState<string | null>(null)

  const onCloseNotification = useCallback(() => {
    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current)
    }
    setMessage(null)
  }, [])

  const addNotification = useCallback((newMessage: string) => {
    setMessage(newMessage)

    timeOutRef.current = setTimeout(() => {
      setMessage(null)
    }, 10000)
  }, [])

  return (
    <AlertNotificationContext.Provider value={{ addNotification, onCloseNotification, message }}>
      <Suspense>
        <AlertNotificationComponent />
      </Suspense>
      {children}
    </AlertNotificationContext.Provider>
  )
}

export default AlertNotificationProvider
